import { Button, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, ListItemText, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { downloadEvidenceFile, listEvidenceFiles } from './evidenceApi';
import { EvidenceOwnerType, evidenceLabel } from './evidenceLogic';

// The files linked to one expense / receipt, each with a Download button (fetched with the caller's token; never a public link).
export function EvidenceFilesDialog({ open, ownerType, ownerId, title, onClose }: { open: boolean; ownerType: EvidenceOwnerType; ownerId: string | null; title: string; onClose: () => void }) {
  const { enqueueSnackbar } = useSnackbar();
  const q = useQuery({ queryKey: ['bc-evidence', ownerType, ownerId], enabled: open && !!ownerId, queryFn: () => listEvidenceFiles(ownerType, ownerId as string) });
  const files = q.data ?? [];
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {q.isLoading && <Typography variant="body2">Loading...</Typography>}
        {!q.isLoading && files.length === 0 && <Typography variant="body2" color="text.secondary">No files attached.</Typography>}
        <List dense>
          {files.map((f) => (
            <ListItem key={f.id} disableGutters secondaryAction={
              <Button size="small" onClick={() => downloadEvidenceFile(f.id, f.originalName).catch(() => enqueueSnackbar('Could not download the file', { variant: 'error' }))}>Download</Button>
            }>
              <ListItemText primary={evidenceLabel(f)} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Close</Button></DialogActions>
    </Dialog>
  );
}
